import React from 'react';
import { useAppTheme } from '../../context/ThemeContext';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error, helperText, leftIcon, rightIcon, ...props }, ref) => {
    const { themeConfig } = useAppTheme();

    const getInputStyles = () => {
      const baseStyles = 'block w-full rounded-md shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
      const errorStyles = error
        ? `border-[${themeConfig.error}] focus:ring-[${themeConfig.error}]`
        : `border-[${themeConfig.accent}] focus:ring-[${themeConfig.primary}]`;
      const iconStyles = (leftIcon || rightIcon) ? 'pl-10' : 'pl-3';
      
      return `${baseStyles} ${errorStyles} ${iconStyles} pr-3 py-2 bg-[${themeConfig.surface}] text-[${themeConfig.text}] border ${className}`;
    };

    return (
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {leftIcon}
          </div>
        )}
        <input
          ref={ref}
          className={getInputStyles()}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            {rightIcon}
          </div>
        )}
        {error && (
          <p className={`mt-1 text-sm text-[${themeConfig.error}]`}>
            {error}
          </p>
        )}
        {helperText && !error && (
          <p className={`mt-1 text-sm text-[${themeConfig.text}] opacity-70`}>
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input; 